import { render } from "./valuation-welcome.vue?vue&type=template&id=56c3def4"
import script from "./valuation-welcome.js?vue&type=script&lang=js"
export * from "./valuation-welcome.js?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__